import { oz } from '@weft/utils';
import { CHANNEL_TYPE } from './channel-type-schema';

export const EmailChannelSchema = oz.object({
  type: oz.literal(CHANNEL_TYPE.Email),
  // When implement notification via email channel, we need to add more configuration here
}).openapi('EmailChannel');

export type EmailChannel = oz.infer<typeof EmailChannelSchema>;